// Copyright (c) 2016 Deere & Company

import PartRequestsSearch from '../../part-requests/search/components';

export default {
    component: PartRequestsSearch,
    name: 'SEARCH',
    path: 'search'
};



// WEBPACK FOOTER //
// ./src/routes/part-requests/search.js